import React, { useState, useEffect, useRef, useMemo } from "react";
import { Empty, Space, Input, Modal  } from 'antd';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { generateClassName } from "jzfz-web-utils";
import { constantConfig, commonUtil } from 'web-common';
import { getQueryParams, ObjTest } from "../../util/common";
import { CommonSearch } from '../../component/commonSearch';
import { CategoryTabs } from '../../component/categoryTabs/CategoryTabs';
import { queryMenuContentList } from '../../store/action';
import { MenuItemVo } from "../../config/menus";
import { InfoModal } from './component/InfoModal';
import { ViewportImg } from '../../component/viewportImg';

import './style/product.less';



const bannerPC = require('../../assets/images/product/projectPCBanner.jpg');
const bannerMOBILE = require('../../assets/images/product/projectMOBILEBanner.jpg');

const { ModuleTypeEnum, WEBSITE_PATHS } = constantConfig;
const { waterColumnsArray } = commonUtil;


// 列表子项边距
const MARGIN = 40;


/**
 * 产品, 作品
 * @constructor
 */
const Product = () => {
	const { menuId = null } = getQueryParams();
	const dispatch = useDispatch();
	const history = useHistory();
	const { menus, isMobile } = useSelector((state: any) => state.reducer);
	// 列表数据
	const [contentList, setContentList] = useState<any[]>([]);
	// 详情容器显隐
	const [visible, setVisible] = useState<boolean>(false);
	// url或tab选中的menuId
	const [activeKey, setActiveKey] = useState<string>(null);
	// 点击图片弹窗显示，当前item
	const [currentItem, setCurrentItem] = useState<any>(null);
	// 容器ref
	const containerRef = useRef<any>(null);

	const currentModule = menus.find((v: MenuItemVo) => v.module === ModuleTypeEnum.PROJECT);

	// 设置渲染的列数
	const columnCount = useMemo(() => isMobile ? 1 : 4, [isMobile]);


	useEffect(() => {
		setActiveKey(menuId);
	}, [menuId]);


	// 初始化数据
	useEffect(() => {
		initData();
	}, [activeKey]);
	


	/**
	 * 初始化方法
	 */
	const initData = async () => {
		const result = await queryMenuContentList(ModuleTypeEnum.PROJECT, activeKey);
		const arrs = result.data || [];
		if (Array.isArray(arrs)) {
			setContentList(arrs);
		}
	};

	
	/**
	 * 计算列的宽度
	 * @param item
	 */
	const getColumnWidth = () => {
		if (containerRef.current && columnCount) {
			const width = containerRef.current.offsetWidth;
			const marginCount = MARGIN * (columnCount - 1);
			return (width - marginCount) / columnCount;
		}
		return 0;
	};


	/**
	 * 处理详情弹窗显示隐藏
	 * @param item 
	 */
	const handleDetailModalVisibleChange = (item?: any) => {
		const tempVisible = item ? true : false;
		setVisible(tempVisible);
		setCurrentItem(item || null);
	};


	/**
	 * 渲染搜索框
	 */
	const renderSearch = () => {
		const SearchInput = (
			<CommonSearch 
				onSearch={(value) => {
					value && history.replace(`${WEBSITE_PATHS.search}?value=${value}`);
				}} 
			/>
		);
		if (isMobile) {
			return (
				<div className="mt16 mb24 plr16">
					<div>{SearchInput}</div>
				</div>
			);
		}
		return (
			<div className="flexjs mt36 mb24 plr72">
				<div title="占位" />
				<div style={{width: 200}}>{SearchInput}</div>
			</div>
		);
	};


	/**
	 * PC端显示的列表
	 * @returns 
	 */
	const renderContentListPC = () => {
		return (
			<div className="plr72">
				<div className="top-line" />
				<div className="w pt12 pb40 flex" ref={containerRef}>
					{
						(waterColumnsArray(contentList, columnCount) || []).map((columns: any[], columnsIndex: number) => {
							return (
								<div 
									key={columnsIndex}
									style={{ width: getColumnWidth(), marginLeft: columnsIndex > 0 ? MARGIN : 0 }}
								>
									{
										ObjTest.isNotEmptyArray(columns) ? (
											columns.map((v, vi) => {
												if (!v) { return null;}
												const { projectName, projectScale, serviceArea, images } = v;
												const showImgUrl = (images || [])[0] || null;
												return (
													<div className="mb40" key={vi} onClick={() => handleDetailModalVisibleChange(v)}>
														<ViewportImg src={showImgUrl} className="w" style={{minHeight: getColumnWidth() * 0.75}} />
														<p className="eps plr5 name mt8 f24">{projectName}</p>
														<p className="eps f14 plr5 desc">项目规模：{projectScale} &nbsp;&nbsp;&nbsp;&nbsp; 服务范围：{serviceArea}</p>
													</div>
												);
											})
										) : (
											null
										)
									}
								</div>
							);
						})
					}
				</div>
			</div>
		);
	};



	/**
	 * 移动端显示的列表
	 * @returns 
	 */
	const renderContentListMobile = () => {
		return (
			<div className="plr16">
				<div className="top-line" />
				<div className="w pt12 pb40 flex">
					<div className="w">
						{
							contentList.map((v, vi) => {
								const { projectName, projectScale, serviceArea, images } = v;
								const showImgUrl = (images || [])[0] || null;
								return (
									<div className="mb40" key={vi} onClick={() => handleDetailModalVisibleChange(v)}>
										<ViewportImg src={showImgUrl} className="w" />
										<p className="eps plr5 name mt8 f16 b">{projectName}</p>
										<p className="eps f14 plr5 desc">项目规模：{projectScale} &nbsp;&nbsp;&nbsp;&nbsp; 服务范围：{serviceArea}</p>
									</div>
								);
							})
						}
					</div>
				</div>
			</div>
		);
	};



	return (
		<div className="company-product-wrapper">
			<div className="">

				{/* banner */}
				<div className="w ofh">
					<img src={isMobile ? bannerMOBILE : bannerPC} loading="lazy" className="w" />
				</div>

				{/* 分类tabs */}
				<div 
					className={generateClassName([
						isMobile ? "p16" : "ptb24 plr72"
					])}
				>
					<CategoryTabs 
						options={currentModule.children || []} 
						activeKey={activeKey}
						onChange={(tabKey: string) => {
							setActiveKey(tabKey);
							history.replace(WEBSITE_PATHS.product);
						}}
					/>
				</div>

				{/* search */}
				{/* {renderSearch()} */}
				
				{
					// 列表
					isMobile ? renderContentListMobile() : renderContentListPC()
				}
				
				{!contentList.length ? (<div className="tc ptb80"><Empty image={Empty.PRESENTED_IMAGE_SIMPLE} /></div>) : (null)}
			</div>

			{/* 点击作品图片的弹窗 */}
			<InfoModal 
				visible={visible}
				item={currentItem}
				list={contentList}
				onFinish={() => {
					handleDetailModalVisibleChange();
				}}
			/>
		</div>
	)
}


export default Product;
